import React from 'react';
import { devWarning, withCoreUIType } from '@tanium/coreui-utils';

export const CONTROL_GROUP_ITEM_COREUITYPE = 'ControlGroupItem';

export interface ControlGroupItemProps {
  /**
   * Inputs and Buttons to be rendered as one unit
   */
  children?: React.ReactNode;
  /**
   * The `flex-grow` value for this ControlGroupItem.
   */
  grow?: number;
}

/**
 * A `ControlGroupItem` for use within `ControlGroup`.
 * This component should only be used as an immediate child of a
 * `ControlGroup` component.
 */
const ControlGroupItemInner = ({ children }: ControlGroupItemProps) => {
  devWarning(
    false,
    'ControlGroupItem component is being rendered unexpectedly. ControlGroupItem components should only be used as direct children of a ControlGroup component.',
  );
  return <>{children}</>;
};

export const ControlGroupItem = withCoreUIType(CONTROL_GROUP_ITEM_COREUITYPE)(
  ControlGroupItemInner,
);
